module.exports = __webpack_public_path__ + "static/media/mobiprint.cf318680.jpg";